'use strict';

module.exports = function(angularModule) {
  angularModule.service('RGSendingStatsService', function($http, $q) {

    this.getNumberOfEmailsSent = function(afterDate, beforeDate) {
      return $http.get("/v5/reviewBuilder/campaign/contact/emailsSent", {params: {afterDate, beforeDate}});
    };

    this.getNumberOfSmssSent = function(afterDate, beforeDate) {
      return $http.get("/v5/reviewBuilder/campaign/contact/smsSent", {params: {afterDate, beforeDate}});
    };

    this.getTotalMessagesForMonth = function() {
      return $http.get("/v5/reviewBuilder/campaign/contact/totalSent");
    };
  });
};
